import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim() || !form.message.trim()) {
      toast.error("Please fill in all fields.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("धन्यवाद! Your enquiry has been received. We will reach out soon.");
      setForm({ name: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Could not send right now — please WhatsApp or call us instead.");
    } finally {
      setSending(false);
    }
  };

  const field =
    "w-full bg-white border border-linen rounded-xl px-5 py-3.5 text-sm text-ink placeholder:text-mut focus:outline-none focus:border-spice focus:ring-2 focus:ring-spice/20 transition-all";

  return (
    <form data-testid="contact-form" onSubmit={handleSubmit} className="flex flex-col gap-4">
      <input
        data-testid="contact-form-name-input"
        className={field}
        placeholder="Your name / आपका नाम"
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
      />
      <input
        data-testid="contact-form-phone-input"
        className={field}
        placeholder="Phone number / फ़ोन नंबर"
        value={form.phone}
        onChange={(e) => setForm({ ...form, phone: e.target.value })}
      />
      <textarea
        data-testid="contact-form-message-input"
        className={`${field} min-h-[130px] resize-y`}
        placeholder="What do you need? Groceries, bulk order, home delivery…"
        value={form.message}
        onChange={(e) => setForm({ ...form, message: e.target.value })}
      />
      <button
        data-testid="contact-form-submit-btn"
        type="submit"
        disabled={sending}
        className="inline-flex items-center justify-center gap-2 bg-spice text-cream font-semibold text-sm px-8 py-4 rounded-full hover:bg-spicedark hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-60"
      >
        <Send size={16} />
        {sending ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
};

export default ContactForm;
